import {Controller, useFormContext} from "react-hook-form";
import {Input, Space} from "antd";
import {FormField, FormFieldError} from "../../../../../../design-system/form-field";
import {ProfileFormValues} from "../../schema-validation";
import {CheckOutlined, LoadingOutlined} from "@ant-design/icons";
import {REBRAND_BASE_URL} from "../../../../../../services/config";
import useDebounce from "../../../../../../hooks/use-debounce";
import {useLegacyVerifyUsername} from "../../../../../../features/profile/hooks/useProfile";

export function ProfilePublicUsernameFormField() {
  const {control, watch} = useFormContext<ProfileFormValues>();
  // const isLoading = false;
  // const isSuccess = true;

  const usernameValue = watch("username");
  const debouncedUsername = useDebounce(usernameValue.toLowerCase(), 2000);
  const {
    isFetching,
    isSuccess,
    isError,
    error: verifyError,
    data: verifyData,
  } = useLegacyVerifyUsername(debouncedUsername);

  const isUsernameAvailable = isSuccess && verifyData?.isAvailable !== false;

  return (
    <FormField
      id="username"
      label="Username"
      renderInput={(id) => (
        <Controller
          control={control}
          name="username"
          render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
            <Space size={8} direction="vertical" style={{display: "flex"}}>
              <Space size={4} direction="vertical" style={{display: "flex"}}>
                <Input
                  addonBefore={`${REBRAND_BASE_URL}/`}
                  id={id}
                  status={
                    error?.message || isError || !isUsernameAvailable ? "error" : ""
                  }
                  onChange={onChange}
                  onBlur={onBlur}
                  size="large"
                  value={value === null ? undefined : value}
                  placeholder="sharon"
                  ref={ref}
                  suffix={
                    isFetching ? (
                      <div>
                        <LoadingOutlined style={{fontSize: 24}} spin />
                      </div>
                    ) : isUsernameAvailable ? (
                      <div>
                        <CheckOutlined />
                      </div>
                    ) : (
                      <></>
                    )
                  }
                />
              </Space>
              <FormFieldError
                errorMessage={
                  error?.message ||
                  verifyError?.message ||
                  (!isUsernameAvailable && isSuccess
                    ? "Username is already taken"
                    : undefined)
                }
              />
            </Space>
          )}
        />
      )}
    />
  );
}
